<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import * as _ from 'lodash';

export default {
  name: 'App',
  mounted() {
    const dtEnvironments = [
      { env: 'uat', src: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf08103qjn/3dbb317dabd9b9eb_complete.js' },
      { env: 'production', src: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf08103qjn/cbc71955721b8ac3_complete.js' }
    ];

    const dtConfig = _.find(dtEnvironments, { env: process.env.BUILD_ENV });
    if (dtConfig) {
      const dynatraceScript = document.createElement('script');
      dynatraceScript.type = 'text/javascript';
      dynatraceScript.src = dtConfig.src;
      dynatraceScript.crossOrigin = 'anonymous';
      document.body.appendChild(dynatraceScript);
    }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.theme--light.v-input--is-disabled .v-label, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: #6b6b6b !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue